<!-- ✅ Akita-based global loading spinner (replaces ngx-spinner) -->
<app-global-loading-spinner></app-global-loading-spinner>

<!-- Legacy ngx-spinner (kept for backward compatibility, can be removed later) -->
<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <div style="color:white; text-align:center; margin-top:8px">{{ spinnerMsg.message$ | async }}</div>
</ngx-spinner> -->

<router-outlet></router-outlet>
